export const API_URL = 'https://api.noroff.dev/api/v1/';
export const LISTINGS_ENDPOINT = 'auction/listings';
export const PROFILE_ENDPOINT = 'auction/profiles';
export const AUTH_ENDPOINT = 'auction/auth';
